import { useState } from 'react'

type Section = {
  label: string
  key: string
}

type UseSectionsProps = {
  defaultActive?: number
  sections: Section[]
}

export const useSections = ({ defaultActive = 0, sections }: UseSectionsProps) => {
  const [active, setActive] = useState(defaultActive)

  const handleChange = (index: number) => {
    setActive(index)
    const section = sections[index].key
    const div = document.getElementById('layout-data')
    const accordionElement = document.getElementById(section)
    if (accordionElement && div)
      div.scrollTo({
        top: accordionElement.offsetTop - 100,
        behavior: 'smooth'
      })
  }

  return { active, handleChange }
}
